import constants from "../constants";
import { NON_ALLOWED_PEOPLEMODULES_ENVS } from './constants';
import appStateProvider from './appStateProvider.js';

export const filterCheckInFromMenus = (modules) => {
  // THIS WILL FILTER THE SAME FORM THE LOOP MENU LIST
  const checkInMenu = constants.ModuleType.find(
    (item) => item.Name === "Check-In"
  );
  modules = modules.filter((item) => item.subType !== String(checkInMenu.Id));
  return modules;
};

export const findCheckInFromMenus = (modules) => {
  const checkInMenu = constants.ModuleType.find(
    (item) => item.Name === "Check-In"
  );
  return modules.find((item) => item.subType === String(checkInMenu.Id));
};

const getChmsModuleIds =()=>{
  return constants.ModuleType
  .filter(module=> module.Group === "Chms")
  .map(module => module.Id);
}

export const checkPeopleModulesAccessible = ()=>{
  const appState = appStateProvider();
  const activeEnvironment = appState.getActiveEnvironment();

  return !NON_ALLOWED_PEOPLEMODULES_ENVS.includes(activeEnvironment);
}

export const filterPeopleModules = (modules) => {
  const peopleModuleTypes = new Set(getChmsModuleIds());
  return modules.filter(item => !peopleModuleTypes.has(Number(item.subType)));
};

export const applyModulesFilter = (modules) => {
  const filteredModules = filterCheckInFromMenus(modules);
  
  // if (!checkPeopleModulesAccessible()) {
  //   return filterPeopleModules(filteredModules);
  // }

  return filteredModules;
};